export const WHATSAPP_LINK =
  'https://api.whatsapp.com/send/?phone=51981791721&text=Hola+me+das+m%C3%A1s+informaci%C3%B3n+del+Auto+Efectivo&type=phone_number&app_absent=0';
export const WHATSAPP_LINK_ECOMMERCE =
  'https://api.whatsapp.com/send/?phone=+51975135000&text=Hola,%20deseo%20saber%20m%C3%A1s%20del%20Seguro%20Vehicular%20Pac%C3%ADfico';
